export default __webpack_public_path__ + "static/media/Xx.d2899179.wav";